function SettingGroup(props: {
    name?: string;
    children: React.ReactNode|React.ReactNode[];
}) {
    return (
        <div className="mb-12">
            {
                props.name && <h2 className="font-bold mb-4">{props.name}</h2>
            }
            {props.children}
        </div>
    );
}
export default SettingGroup;